import React from 'react'
import {Global} from '@emotion/react'

const PromoCustomStyles = () => {
    return (
        <Global
            styles={`
                @keyframes promo-fade-out {
                    0% {
                        transform: translate(0, 0);
                        opacity: 1;
                    }
                    100% {
                        transform: translate(0, -10px);
                        opacity: 0;
                    }
                }

                @keyframes promo-fade-in {
                    0% {
                        transform: translate(0, 10px);
                        opacity: 0;
                    }
                    100% {
                        transform: translate(0, 0);
                        opacity: 1;
                    }
                }

                // promo dropdown styles
                .promo-bar-details {
                    width: 100%;
                }
                .promo-bar-details .title {
                    font-family: var(--chakra-fonts-inter);
                    color: var(--chakra-colors-black-100);
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 25px;
                    letter-spacing: .08px;
                    text-transform: none;
                    margin-bottom: 5px
                }

                .promo-bar-details .description {
                    font-family: var(--chakra-fonts-inter);
                    color: var(--chakra-colors-black-100);
                    font-size: 13px;
                    font-weight: 300;
                    line-height: 22px;
                    letter-spacing: .065px;
                    text-transform: none;
                    margin-bottom: 15px
                }

                .promo-bar-details .cta .dark-button,.promo-bar-details .cta .glass-button {
                    border-radius: 90px;
                    display: inline-block
                }

                .promo-bar-details .cta .dark-button {
                    color: var(--chakra-colors-gray-200);
                    background: var(--chakra-colors-black-100);
                    margin-right: 10px
                }

                .promo-bar-details .cta .dark-button,.promo-bar-details .cta .glass-button {
                    font-family: var(--chakra-fonts-inter);
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 22px;
                    letter-spacing: .07px;
                    text-transform: none;
                    padding: 4px 25px
                }

                    .promo-bar-details .cta .glass-button {
                    border: 1px solid var(--chakra-colors-black-100);
                    color: var(--chakra-colors-black-100);
                }
                .header-shipping-banner .all-offers-arrow {
                    background: url(https://res.cloudinary.com/kendra-scott/image/upload/v1722341200/UIImages/images/interface/down-small.svg) 50%;
                    background-repeat: no-repeat;
                    width: 20px;
                    height: 20px;
                    display: block;
                    position: relative;
                    order: 4;
                }
                // promo dropdown styles

                .promo-banner-wrapper > div {
                    width: 100%;
                }

                .promo-banner-wrapper {
                    z-index: 1 !important;
                }

                .html-slot-container{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 22px;
                }
                .html-slot-container .promobar-timer-data {
                    font-family: 'Cormorant';
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                    letter-spacing: 0.09px;
                    color: 'var(--chakra-colors-gray-black.100)';
                    padding-left: 17px;
                    box-sizing: border-box;
                    height: 22px;
                    position: relative;
                    order: 3;
                    flex: 0 0 auto;
                    white-space: nowrap;

                    @media (max-width: 768px) {
                        height: 60px;
                        display: flex;
                        align-items: center;
                    }
                }

                .html-slot-container .banner-box.with-timer .promobar-timer-data::before {
                    content: ""; 
                    border-left: .5px solid;
                    border-color: #D9C3D2;
                    display: block;
                    position: absolute; 
                    width: .5px; 
                    height: 22px;
                    left: -1%; 
                    top: 50%;
                    transform: translateY(-50%);
                }
                    
                .html-slot-container .banner-box.with-timer .show-all-offers {
                    padding-right: 10px;
                }

                .banner-box {
                    font-family: 'Cormorant';
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 300;
                    letter-spacing: 0.08px;
                    color: black;
                    cursor: pointer;
                    width: 100%;
                    animation: promo-fade-out 500ms cubic-bezier(0, 0, 0.58, 1);
                    transition: transform 350ms cubic-bezier(0, 0, 0.58, 1),
                    opacity 350ms cubic-bezier(0, 0, 0.58, 1);
                    display: flex;
                    touch-action: manipulation;
                }

                .banner-box.with-timer {
                    display: flex;
                    align-items: center;
                }

                .banner-box:not(.globale-box) {
                    position: absolute;
                    left: 0;
                    right: 0;
                    opacity: 0;
                }

                .banner-container-new:not(.slider) .banner-box {
                    opacity: 1;
                }

                .cta-promo-offers {
                    flex-shrink: 0;
                }

                .banner-box.active {
                    animation: promo-fade-in 500ms cubic-bezier(0, 0, 0.58, 1) forwards;
                    opacity: 1;
                    z-index: 50;
                }

                .banner-box-text {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0 60px;
                    gap: 10px;
                    width: 100%;
                    min-width: 0;
                }

                .banner-box-text:has(.promobar-timer-data) .cta-promo-offers {
                    display: none;
                }

                .banner-box a {
                    text-decoration: none;
                    display: inline;
                    max-width: 100%;
                    min-width: 0;
                }

                .banner-box-text:has(a)::after {
                    content: "⟶";
                    display: inline-block;
                    flex: 0 0 auto;
                    order: 2;
                    width: auto;
                    height: auto;
                    position: relative;
                    top: -1px;
                }

                .banner-container-new {
                    margin: auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    max-width: 100%;
                    width: 100%;
                }

                .header-shipping-banner p {
                    order: 1;
                    flex: 0 1 auto;
                    min-width: 0;
                    max-width: 100%;
                    white-space: normal;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    line-clamp: 1;
                    text-align: center;
                }
            `}
        />
    )
}

export default PromoCustomStyles
